// import { SiteLoader } from '@common/components';
// import { FC, useEffect, useState } from 'react';
// import SelecteOrganizationModel from 'src/components/SelecteOrganization/page';
// import { useAppDispatch, useAppSelector } from 'src/store';
// import { currentAction } from 'src/store/user';

// interface Props {
//   children: JSX.Element;
// }

// const CurrentUserSession: FC<Props> = ({ children }): JSX.Element => {
//   const dispatch = useAppDispatch();
//   const { token, isAuthorize, tenantId, isSuperAdmin, profile_status, userSelectedOrganization } = useAppSelector((state) => state.user.data);
//   const [showPopup, setShowPopup] = useState(false);

//   useEffect(() => {
//     // Check authorization and role to dispatch an action
//     if (token && !isSuperAdmin) {
//       dispatch(currentAction());
//     }
//   }, [isAuthorize, token, dispatch]);
//   useEffect(() => {
//     // Condition to show popup based on profile_status and userSelectedOrganization
//     if (profile_status == "user" && !userSelectedOrganization) {
//       setShowPopup(true);
//     } else {
//       setShowPopup(false);
//     }
//   }, [profile_status, userSelectedOrganization]);

//   return <>

//     {
//       showPopup ? (
//         <SelecteOrganizationModel/>
//       ) : (
//         tenantId ? (
//           <>
//             {children}
//             {showPopup && <SelecteOrganizationModel />}
//           </>
//         ) : (
//           <SiteLoader /> 
//         )
//       )
//     }
//   </>
// };

// export default CurrentUserSession;


import { SiteLoader } from '@common/components';
import { FC, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store';
import { currentAction } from 'src/store/user';

interface Props {
  children: JSX.Element;
}

const CurrentUserSession: FC<Props> = ({ children }): JSX.Element => {
  const dispatch = useAppDispatch();
  const { token, isAuthorize, tenantId, isSuperAdmin } = useAppSelector((state) => state.user.data);

  useEffect(() => {
    if (token && !isSuperAdmin) {
      dispatch(currentAction());
    }
  }, [isAuthorize, token]);

  return tenantId ? <>{children}</> : <SiteLoader />;
};

export default CurrentUserSession;
